//React
import React from 'react'
import {
  Link
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as paymentTicketAction from '../action/paymentTicketAction';
import * as helpAction from '../action/helpAction';
//Material-ui
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
//Add
import moment from 'moment';
//Icon

//Part
import PartUserName from './PartUserName';
import PartPageTitle from './PartPageTitle';

//Dialog

class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      sampleList: [],
      keywordAddFreeText: '',
      keywordAddFreeTextErr: null,
      keywordAddFreeTextValid: false,
      keywordAddSampleText: null,
      keywordDelId: null,
  	}
  }

  componentDidMount() {
    document.title = '応援チケット - パートナーズ';
    this.props.paymentTicketReceiverListGet();
  };

  _renderList(value, index, arr) {
    return (
      <div key={index}>
        <div
          style={{
            padding: '5px',
            backgroundColor: (value.payment_ticket_accept_seen === 0) ? '#FFE7C2': 'initial'
          }}
        >
          <Link to={{ pathname: '/partner/' + value.userdata_id_code}}>
            <PartUserName
              data={{
                name: value.userdata_name,
                sex: value.userdata_sex,
                size: '1.2em',
              }}
            />
          </Link>&nbsp;
          <span>
            有料サービス{value.payment_ticket_day}日
          </span>&nbsp;
          <span>
            {moment(value.payment_ticket_used_date).format("YYYY年MM月DD日")}
          </span>
        </div>
        {
          (arr.length - 1 > index) &&
          <Divider />
        }

      </div>
    );
  }

  render() {
      return (
        <div>
          <PartPageTitle
            title={'受け取った応援チケット'}
            onback={ '/' }
          />
          <div style={{maxWidth:'400px', margin:'auto'}}>
            {
              (this.props.paymentTicket.receiver.list.length > 0) ? (
                <Box boxShadow={2} style={{background:'#FFF'}}>
                  {
                    this.props.paymentTicket.receiver.list.map(
                      (value, index, arr) => this._renderList(value, index, arr)
                    )
                  }
                </Box>
              ): (
                <h2 align='center' style={{padding:'30px 0px'}}>
                  貰った応援チケットは<br/>見つかりませんでした
                </h2>
              )
            }
          </div>

          <div align='center' style={{margin:'15px'}}>
            <Button
              color="primary"
              variant={ "outlined" }
              onClick={ () => this.props.helpOpen('category','ticket') }
            >
              「応援チケット」とは？
            </Button>
          </div>

        </div>

      )

  }
}


const mapStateToProps = (state) => {
	return {
		paymentTicket: state.paymentTicket,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...paymentTicketAction,
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
